import StudentAnswer from '@/components/gaia/student/task/student-answer';
import TaskFeedback from '@/components/gaia/student/task/task-feedback';
import { verifyContentOfEditorIsEmpty } from '~/helpers/stringHelper';
import { VRuntimeShell } from '@grupoa/components';
import { Dropzone } from '@grupoa/editor-html';

import TaskMixin from '@/mixins/task';
import GetStudentTypeMixin from '@/mixins/student-type';

export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    content: {
      type    : Object,
      default : () => ({})
    },
    selectedAttempt: {
      type    : Object,
      default : () => ({})
    }
  },
  mixins     : [TaskMixin, GetStudentTypeMixin],
  components : {
    Dropzone,
    StudentAnswer,
    TaskFeedback,
    VRuntimeShell
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    checkHtmlIsEmpty(value) {
      return verifyContentOfEditorIsEmpty(value);
    },
    getPercentage(grade, total) {
      return (Number(grade) / Number(total)) * 100;
    },
    formatNumber(number) {
      if (number) {
        return Number(number).toLocaleString({ maximumFractionDigits: 2 });
      }
      return null;
    }
  }
};
